(function () {
  'use strict';

  var LEGACY_HEADER = 'CARD MESSAGE — ';
  var NOTE_SEPARATOR = ' || ';
  var NEW_PREFIX = '[CARD MESSAGE — ';
  var NEW_MIDDLE = '] ';
  var LINE_BREAK_TOKEN = ' ↵ ';

  function jsonRequest(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = options.headers || {};
    options.headers.Accept = 'application/json';

    return window.fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function readCart() {
    return jsonRequest('/cart.js', { method: 'GET' });
  }

  function saveCartNote(note) {
    return jsonRequest('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: note })
    });
  }

  function getProductData() {
    var node = document.querySelector('script[id^="ProductJson-"]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || node.innerText || '{}');
    } catch (error) {
      return null;
    }
  }

  function getItemHandle(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);

    if (item.url) {
      var match = String(item.url).match(/\/products\/([^?/#]+)/);
      if (match && match[1]) return match[1];
    }

    if (item.product_id) return 'product-' + String(item.product_id);
    return '';
  }

  function getItemTitle(item) {
    if (!item) return 'Product';
    return String(item.product_title || item.title || item.handle || 'Product');
  }

  function findItemByTitle(items, title) {
    var cleanTitle = String(title || '').replace(/^\s+|\s+$/g, '');
    var i;

    for (i = 0; i < items.length; i += 1) {
      if (getItemTitle(items[i]) === cleanTitle) return items[i];
    }

    return null;
  }

  function findTitleAtStart(items, text) {
    var candidates = items.slice().sort(function (a, b) {
      return getItemTitle(b).length - getItemTitle(a).length;
    });
    var i;

    for (i = 0; i < candidates.length; i += 1) {
      var title = getItemTitle(candidates[i]);
      if (text.indexOf(title) === 0) {
        return {
          item: candidates[i],
          title: title,
          rest: text.slice(title.length)
        };
      }
    }

    return null;
  }

  function encodeMessage(message) {
    return String(message || '')
      .replace(/\r\n|\r|\n/g, LINE_BREAK_TOKEN)
      .replace(/\|\|/g, '｜｜')
      .replace(/^\s+|\s+$/g, '');
  }

  function decodeMessage(message) {
    return String(message || '')
      .replace(/｜｜/g, '||')
      .split(LINE_BREAK_TOKEN).join('\n')
      .replace(/^\s+|\s+$/g, '');
  }

  function isInternalMessage(value) {
    var text = String(value || '');
    return text.indexOf(NEW_PREFIX) !== -1 ||
      text.indexOf(LEGACY_HEADER) !== -1 ||
      /\[CARD MESSAGE\s*[—-]/i.test(text);
  }

  function sanitizeCustomerMessage(value) {
    var text = String(value || '').replace(/^\s+|\s+$/g, '');
    if (!text || isInternalMessage(text)) return '';
    return text;
  }

  function parseNewFormat(text, items, messages) {
    text.split(NOTE_SEPARATOR).forEach(function (segment) {
      var match = segment.match(/^\[CARD MESSAGE — (.+?)\]\s*(.*)$/);
      if (!match) return;

      var item = findItemByTitle(items, match[1]);
      if (!item) return;

      var decoded = sanitizeCustomerMessage(decodeMessage(match[2]));
      if (!decoded) return;

      messages[getItemHandle(item)] = decoded;
    });
  }

  function parseLegacyMultiline(text, items, messages) {
    var lines = text.replace(/\r\n/g, '\n').split('\n');
    var currentItem = null;
    var buffer = [];

    function commit() {
      if (!currentItem) return;
      var decoded = sanitizeCustomerMessage(buffer.join('\n'));
      if (decoded) messages[getItemHandle(currentItem)] = decoded;
      currentItem = null;
      buffer = [];
    }

    lines.forEach(function (line) {
      if (line.indexOf(LEGACY_HEADER) === 0) {
        commit();
        currentItem = findItemByTitle(items, line.slice(LEGACY_HEADER.length));
      } else if (currentItem) {
        buffer.push(line);
      }
    });

    commit();
  }

  function parseLegacyWithHeaders(text, items, messages) {
    var parts = text.split(LEGACY_HEADER);

    parts.forEach(function (part, index) {
      if (index === 0 || !part) return;

      var clean = part.replace(/^\s+/, '');
      var titleMatch = findTitleAtStart(items, clean);
      if (!titleMatch) return;

      var remainder = titleMatch.rest
        .replace(/^\s*[:\-–—]?\s*/, '')
        .replace(/^\s+|\s+$/g, '');

      var decoded = sanitizeCustomerMessage(decodeMessage(remainder));
      if (decoded) messages[getItemHandle(titleMatch.item)] = decoded;
    });
  }

  function parseCardMessages(note, items) {
    var messages = {};
    var text = typeof note === 'string' ? note : '';
    var trimmed = text.replace(/^\s+|\s+$/g, '');

    if (!trimmed) return messages;

    if (text.indexOf(NEW_PREFIX) !== -1) {
      parseNewFormat(text, items, messages);
      return messages;
    }

    if (text.indexOf(LEGACY_HEADER) !== -1) {
      if (text.indexOf('\n') !== -1) {
        parseLegacyMultiline(text, items, messages);
      } else {
        parseLegacyWithHeaders(text, items, messages);
      }
      return messages;
    }

    if (items.length === 1) {
      var legacyMessage = sanitizeCustomerMessage(trimmed);
      if (legacyMessage) messages[getItemHandle(items[0])] = legacyMessage;
    }

    return messages;
  }

  function serializeCardMessages(items, messages) {
    var sections = [];
    var seen = {};

    items.forEach(function (item) {
      var handle = getItemHandle(item);
      if (!handle || seen[handle]) return;
      seen[handle] = true;

      var message = messages[handle];
      if (typeof message !== 'string') return;

      message = sanitizeCustomerMessage(message);
      if (!message) return;

      sections.push(
        NEW_PREFIX + getItemTitle(item) + NEW_MIDDLE + encodeMessage(message)
      );
    });

    return sections.join(NOTE_SEPARATOR);
  }

  function buildProductMessageBlock() {
    var details = document.createElement('details');
    details.className = 'ay-product-card-message';
    details.setAttribute('data-ay-product-card-message', '');

    var summary = document.createElement('summary');
    summary.className = 'ay-product-card-message__summary';
    summary.innerHTML =
      '<span class="ay-product-card-message__label">Card Message</span>' +
      '<span class="ay-product-card-message__free">Complimentary</span>' +
      '<span class="ay-product-card-message__icon" aria-hidden="true"></span>';

    var body = document.createElement('div');
    body.className = 'ay-product-card-message__body';

    var textarea = document.createElement('textarea');
    textarea.className = 'ay-product-card-message__input';
    textarea.setAttribute('data-ay-card-message-input', '');
    textarea.setAttribute('rows', '3');
    textarea.setAttribute('maxlength', '500');
    textarea.setAttribute('placeholder', 'Write your personal message…');
    textarea.setAttribute('aria-label', 'Card Message');

    var helper = document.createElement('p');
    helper.className = 'ay-product-card-message__helper';
    helper.textContent = 'We’ll print your message on a premium card and include it with your flowers at no extra charge.';

    var error = document.createElement('p');
    error.className = 'ay-product-card-message__error';
    error.setAttribute('data-ay-card-message-error', '');
    error.setAttribute('role', 'alert');
    error.hidden = true;

    body.appendChild(textarea);
    body.appendChild(helper);
    body.appendChild(error);
    details.appendChild(summary);
    details.appendChild(body);

    return details;
  }

  function initProductCardMessage() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (!window.fetch) return;

    var product = getProductData();
    if (!product || !product.handle) return;

    var form = document.querySelector('.product-section[data-section-type="product-template"] form.variations_form.cart');
    if (!form || form.querySelector('[data-ay-product-card-message]')) return;

    var buttonArea = form.querySelector('.variations_button');
    var addButton = form.querySelector('.add_to_cart_button');
    if (!buttonArea || !addButton) return;

    var block = buildProductMessageBlock();
    form.insertBefore(block, buttonArea);

    var textarea = block.querySelector('[data-ay-card-message-input]');
    var error = block.querySelector('[data-ay-card-message-error]');
    var skipNextClick = false;
    var saving = false;
    var productHandle = product.handle;

    readCart().then(function (cart) {
      var items = cart.items || [];
      var messages = parseCardMessages(cart.note || '', items);
      var canonicalNote = serializeCardMessages(items, messages);

      textarea.value = sanitizeCustomerMessage(messages[productHandle] || '');

      if (canonicalNote !== (cart.note || '')) {
        saveCartNote(canonicalNote).catch(function () {});
      }
    }).catch(function () {});

    addButton.addEventListener('click', function (event) {
      if (skipNextClick) {
        skipNextClick = false;
        return;
      }

      if (saving) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      saving = true;
      addButton.classList.add('ay-card-note-saving');
      error.hidden = true;
      error.textContent = '';

      readCart().then(function (cart) {
        var items = (cart.items || []).slice();
        var messages = parseCardMessages(cart.note || '', items);
        var exists = items.some(function (item) {
          return getItemHandle(item) === productHandle;
        });

        messages[productHandle] = textarea.value || '';

        if (!exists) {
          items.push({
            handle: productHandle,
            product_title: product.title || productHandle
          });
        }

        return saveCartNote(serializeCardMessages(items, messages));
      }).then(function () {
        saving = false;
        addButton.classList.remove('ay-card-note-saving');
        skipNextClick = true;
        addButton.click();
      }).catch(function () {
        saving = false;
        addButton.classList.remove('ay-card-note-saving');
        error.textContent = 'We could not save your Card Message. Please try again.';
        error.hidden = false;
      });
    }, true);
  }

  function normalizePropertyKey(key, value) {
    var rawKey = String(key || '').replace(/^\s+|\s+$/g, '');
    var rawValue = String(value || '');
    var combined = (rawKey + ' ' + rawValue).toLowerCase();

    if (combined.indexOf('delivery / pickup date') !== -1 ||
        combined.indexOf('delivery pickup date') !== -1 ||
        combined.indexOf('delivery date') !== -1) {
      return 'Delivery / Pickup Date';
    }

    return rawKey;
  }

  function normalizePropertyValue(key, value) {
    var raw = String(value || '');
    var combined = (String(key || '') + ' ' + raw).toLowerCase();

    if (combined.indexOf('delivery') !== -1 && combined.indexOf('date') !== -1) {
      var dates = (String(key || '') + ' ' + raw).match(/\d{1,2}\/\d{1,2}\/\d{4}/g);
      if (dates && dates.length) return dates[0];
    }

    return raw.replace(/^\s+|\s+$/g, '');
  }

  function getCleanProperties(item) {
    var properties = item && item.properties ? item.properties : {};
    var rows = [];
    var seen = {};

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!key || key.charAt(0) === '_') return;
      if (value === null || value === undefined || String(value).replace(/^\s+|\s+$/g, '') === '') return;

      var cleanKey = normalizePropertyKey(key, value);
      var cleanValue = normalizePropertyValue(key, value);
      if (!cleanKey || !cleanValue) return;
      if (/^\d+$/.test(cleanKey) && cleanValue.indexOf('/') === -1) return;

      var dedupeKey = cleanKey.toLowerCase() + '|' + cleanValue.toLowerCase();
      if (seen[dedupeKey]) return;
      seen[dedupeKey] = true;
      rows.push({ key: cleanKey, value: cleanValue });
    });

    return rows;
  }

  function cleanCartItemMeta(row, item, index) {
    var cell = row.querySelector('.product-name');
    if (!cell) return;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var variantMeta = cell.querySelector('.cart_meta .variation');
    var variantWrap = variantMeta ? variantMeta.parentNode : null;
    var properties = getCleanProperties(item);

    Array.prototype.forEach.call(cell.querySelectorAll('.cart_meta'), function (meta) {
      if (!meta.querySelector('.variation')) meta.style.display = 'none';
    });

    var oldClean = cell.querySelector('.ay-cart-clean-properties');
    if (oldClean) oldClean.parentNode.removeChild(oldClean);

    if (isMobile) {
      var details = [];
      var seen = {};

      function addDetail(key, value) {
        var cleanKey = String(key || '').replace(/:\s*$/, '').replace(/^\s+|\s+$/g, '');
        var cleanValue = String(value || '').replace(/^\s+|\s+$/g, '');
        if (!cleanKey || !cleanValue) return;

        var dedupeKey = cleanKey.toLowerCase() + '|' + cleanValue.toLowerCase();
        if (seen[dedupeKey]) return;
        seen[dedupeKey] = true;
        details.push({ key: cleanKey, value: cleanValue });
      }

      if (variantMeta) {
        var labels = variantMeta.querySelectorAll('dt');
        var values = variantMeta.querySelectorAll('dd');

        Array.prototype.forEach.call(labels, function (label, i) {
          addDetail(label.textContent, values[i] ? values[i].textContent : '');
        });
      }

      properties.forEach(function (property) {
        addDetail(property.key, property.value);
      });

      if (variantWrap) variantWrap.style.display = 'none';

      var existingDetailsRow = document.querySelector('.ay-cart-item-details-row[data-ay-details-index="' + index + '"]');
      if (existingDetailsRow && existingDetailsRow.parentNode) {
        existingDetailsRow.parentNode.removeChild(existingDetailsRow);
      }

      if (details.length && row.parentNode) {
        var detailsRow = document.createElement('tr');
        detailsRow.className = 'ay-cart-item-details-row';
        detailsRow.setAttribute('data-ay-details-index', String(index));

        var detailsCell = document.createElement('td');
        detailsCell.colSpan = Math.max(row.children ? row.children.length : 1, 1);
        detailsCell.className = 'ay-cart-item-details-cell';

        var detailsWrap = document.createElement('div');
        detailsWrap.className = 'ay-cart-item-details';

        details.forEach(function (detail) {
          var line = document.createElement('div');
          line.className = 'ay-cart-item-detail';

          var label = document.createElement('span');
          label.className = 'ay-cart-item-detail__label';
          label.textContent = detail.key + ':';

          var value = document.createElement('span');
          value.className = 'ay-cart-item-detail__value';
          value.textContent = detail.value;

          line.appendChild(label);
          line.appendChild(value);
          detailsWrap.appendChild(line);
        });

        detailsCell.appendChild(detailsWrap);
        detailsRow.appendChild(detailsCell);
        row.parentNode.insertBefore(detailsRow, row.nextSibling);
      }

      return;
    }

    if (!properties.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'ay-cart-clean-properties';

    properties.forEach(function (property) {
      var line = document.createElement('div');
      line.className = 'ay-cart-clean-property';

      var label = document.createElement('span');
      label.className = 'ay-cart-clean-property__label';
      label.textContent = property.key + ':';

      var value = document.createElement('span');
      value.className = 'ay-cart-clean-property__value';
      value.textContent = property.value;

      line.appendChild(label);
      line.appendChild(value);
      wrap.appendChild(line);
    });

    if (variantWrap && variantWrap.parentNode === cell) {
      variantWrap.insertAdjacentElement('afterend', wrap);
    } else {
      var title = cell.querySelector('.item_title');
      if (title) title.insertAdjacentElement('afterend', wrap);
      else cell.insertBefore(wrap, cell.firstChild);
    }
  }

  function buildCartItemMessageEditor(item, message, index) {
    var root = document.createElement('div');
    var textareaId = 'ay-cart-card-message-' + index;
    var hasMessage = !!(message && message.replace(/^\s+|\s+$/g, ''));

    root.className = 'ay-cart-item-card-message';
    root.setAttribute('data-ay-cart-item-card-message', '');
    root.setAttribute('data-ay-card-handle', getItemHandle(item));

    root.innerHTML =
      '<div class="ay-cart-item-card-message__view" data-ay-card-view>' +
        '<div class="ay-cart-item-card-message__topline">' +
          '<span class="ay-cart-item-card-message__title" data-ay-card-title></span>' +
          '<button type="button" class="ay-cart-item-card-message__edit" data-ay-card-edit>' + (hasMessage ? 'EDIT MESSAGE' : 'ADD MESSAGE') + '</button>' +
        '</div>' +
        '<div class="ay-cart-item-card-message__text' + (hasMessage ? '' : ' is-empty') + '" data-ay-card-text></div>' +
      '</div>' +
      '<div class="ay-cart-item-card-message__editor" data-ay-card-editor hidden>' +
        '<label class="ay-cart-item-card-message__editor-label" data-ay-card-editor-label for="' + textareaId + '"></label>' +
        '<textarea id="' + textareaId + '" class="ay-cart-item-card-message__textarea" rows="3" maxlength="500" placeholder="Write your personal message…"></textarea>' +
        '<div class="ay-cart-item-card-message__actions">' +
          '<button type="button" class="ay-cart-item-card-message__save" data-ay-card-save>SAVE</button>' +
          '<button type="button" class="ay-cart-item-card-message__cancel" data-ay-card-cancel>CANCEL</button>' +
        '</div>' +
        '<p class="ay-cart-item-card-message__status" data-ay-card-status role="status" aria-live="polite"></p>' +
      '</div>';

    var cartTitle = 'Card Message for: ' + getItemTitle(item);
    root.querySelector('[data-ay-card-title]').textContent = cartTitle;
    root.querySelector('[data-ay-card-editor-label]').textContent = cartTitle;
    root.querySelector('[data-ay-card-text]').textContent = hasMessage ? sanitizeCustomerMessage(message) : 'No message added';
    root.querySelector('.ay-cart-item-card-message__textarea').value = sanitizeCustomerMessage(message);

    return root;
  }

  function clearDynamicCartUi() {
    Array.prototype.forEach.call(document.querySelectorAll('.ay-cart-card-message-row, .ay-cart-item-details-row'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-ay-cart-item-card-message]'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    Array.prototype.forEach.call(document.querySelectorAll('.ay-cart-clean-properties'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function placeCartEditor(row, cell, editor, index) {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    if (!isMobile) {
      cell.appendChild(editor);
      return;
    }

    var messageRow = document.createElement('tr');
    messageRow.className = 'ay-cart-card-message-row';
    messageRow.setAttribute('data-ay-card-index', String(index));

    var messageCell = document.createElement('td');
    messageCell.colSpan = Math.max(row.children ? row.children.length : 1, 1);
    messageCell.className = 'ay-cart-card-message-cell';
    messageCell.appendChild(editor);

    messageRow.appendChild(messageCell);

    if (row.parentNode) {
      var detailsRow = document.querySelector('.ay-cart-item-details-row[data-ay-details-index="' + index + '"]');
      if (detailsRow && detailsRow.parentNode === row.parentNode) {
        row.parentNode.insertBefore(messageRow, detailsRow.nextSibling);
      } else {
        row.parentNode.insertBefore(messageRow, row.nextSibling);
      }
    } else {
      cell.appendChild(editor);
    }
  }

  function initCartMessageEditors(forceRebuild) {
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    if (!window.fetch) return;

    var nativeNote = document.getElementById('cart-note');
    if (!nativeNote) return;

    var nativeWrap = nativeNote.closest ? nativeNote.closest('.cart-note') : null;
    if (nativeWrap) nativeWrap.classList.add('ay-cart-note-native-hidden');

    if (forceRebuild) clearDynamicCartUi();

    readCart().then(function (cart) {
      var items = cart.items || [];
      if (!items.length) return;

      var messages = parseCardMessages(cart.note || '', items);
      var rows = document.querySelectorAll('tr.cart_item');
      var canonicalNote = serializeCardMessages(items, messages);

      nativeNote.value = canonicalNote;

      if (canonicalNote !== (cart.note || '')) {
        saveCartNote(canonicalNote).then(function (updatedCart) {
          nativeNote.value = updatedCart && typeof updatedCart.note === 'string'
            ? updatedCart.note
            : canonicalNote;
        }).catch(function () {});
      }

      var cartForm = nativeNote.form || (nativeNote.closest ? nativeNote.closest('form') : null);
      if (cartForm && !cartForm.getAttribute('data-ay-card-submit-bound')) {
        cartForm.setAttribute('data-ay-card-submit-bound', '1');
        cartForm.addEventListener('submit', function () {
          nativeNote.value = serializeCardMessages(items, messages);
        }, true);
      }

      Array.prototype.forEach.call(rows, function (row, index) {
        var item = items[index];
        if (!item) return;

        cleanCartItemMeta(row, item, index);

        var cell = row.querySelector('.product-name');
        if (!cell || row.querySelector('[data-ay-cart-item-card-message]')) return;
        if (document.querySelector('.ay-cart-card-message-row[data-ay-card-index="' + index + '"]')) return;

        var handle = getItemHandle(item);
        var editor = buildCartItemMessageEditor(item, messages[handle] || '', index);
        placeCartEditor(row, cell, editor, index);

        var view = editor.querySelector('[data-ay-card-view]');
        var editPanel = editor.querySelector('[data-ay-card-editor]');
        var text = editor.querySelector('[data-ay-card-text]');
        var textarea = editor.querySelector('.ay-cart-item-card-message__textarea');
        var status = editor.querySelector('[data-ay-card-status]');
        var editButton = editor.querySelector('[data-ay-card-edit]');
        var saveButton = editor.querySelector('[data-ay-card-save]');
        var cancelButton = editor.querySelector('[data-ay-card-cancel]');

        function renderValue(value) {
          var clean = sanitizeCustomerMessage(value);
          text.textContent = clean || 'No message added';
          text.classList.toggle('is-empty', !clean);
          editButton.textContent = clean ? 'EDIT MESSAGE' : 'ADD MESSAGE';
        }

        function showView() {
          view.hidden = false;
          editPanel.hidden = true;
          status.textContent = '';
        }

        function showEditor() {
          textarea.value = sanitizeCustomerMessage(messages[handle] || '');
          view.hidden = true;
          editPanel.hidden = false;
          status.textContent = '';
          textarea.focus();
        }

        editButton.addEventListener('click', showEditor);

        cancelButton.addEventListener('click', function () {
          textarea.value = messages[handle] || '';
          showView();
        });

        saveButton.addEventListener('click', function () {
          if (saveButton.disabled) return;

          var nextValue = sanitizeCustomerMessage(textarea.value || '');
          messages[handle] = nextValue;
          var nextNote = serializeCardMessages(items, messages);

          saveButton.disabled = true;
          status.textContent = 'Saving…';

          saveCartNote(nextNote).then(function (updatedCart) {
            nativeNote.value = updatedCart && typeof updatedCart.note === 'string'
              ? updatedCart.note
              : nextNote;

            messages[handle] = nextValue;
            renderValue(nextValue);
            status.textContent = 'Saved.';
            saveButton.disabled = false;
            window.setTimeout(showView, 300);
          }).catch(function () {
            saveButton.disabled = false;
            status.textContent = 'Could not save. Please try again.';
          });
        });
      });
    }).catch(function () {});
  }

  function init() {
    initProductCardMessage();
    initCartMessageEditors(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted && document.body && document.body.classList.contains('template-cart')) {
      initCartMessageEditors(true);
    }
  });
})();